import React from "react"
import { getAllIndustries } from "../../utils"
import SelectField from "../SelectField"

const industryList = getAllIndustries().map(industry => ({
  value: industry.name.toLowerCase(),
  label: industry.name
}))

function IndustryField(props) {
  return (
    <span className="IndustryField">
      <SelectField
        {...props}
        isSearchable={true}
        options={industryList}
        defaultValue={{ value: "none", label: "" }}
      />
    </span>
  )
}

export default IndustryField
